module.exports = __webpack_public_path__ + "static/media/camera-icon.1897ec43.svg";